var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('Navbar'),_c('keep-alive',{attrs:{"include":['Blog', 'Portfolio']}},[_c('router-view')],1),_c('vue-easy-lightbox',{attrs:{"visible":_vm.lightbox.visible,"imgs":_vm.lightbox.imgs,"index":_vm.lightbox.index},on:{"hide":_vm.hideImg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }